<div *ngIf="calculatedPremiums$ | async; else loadingSpinner">
<h2 nxHeadline="section">{{'dataSummary.title' | translate}}</h2>
<form>
    <div class="panel">
        <qbe-panel-component>
            <div class="row mobifix-vd"
                 nxRow>
                <div nxCol="12, 12, 4">
                    <h2 class="panel-header">{{'dataSummary.propertyDetails' | translate}}</h2>
                    <div class="illustration illustration-house">
                        <img aemNormalizeUrl 
                             alt="Family with house holding a check mark"
                             src="/assets/img/family_with_house_holding_a_check_mark.svg">
                    </div>
                </div>
                <div class="vehicle-data"
                     nxCol="12, 12, 5"
                     colOffset="0,0,2">
                    <qbe-bluebox>
                        <div class="line">
                            <p>{{'dataSummary.postalCode' | translate}}</p>
                            <p>{{formValues.postCode}}</p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertyCity' | translate}}</p>
                            <p>{{formValues.cityName}}</p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertyAddress' | translate}}</p>
                            <p>{{formValues.street}}
                                <span *ngIf="formValues.streetNumber"> {{formValues.streetNumber}} </span>
                                <span *ngIf="formValues.block">бл. {{formValues.block}} </span>
                                <span *ngIf="formValues.entrance">вх. {{formValues.entrance}} </span>
                                <span *ngIf="formValues.floor">ет. {{formValues.floor}} </span>
                                <span *ngIf="formValues.apartment">ап. {{formValues.apartment}} </span>
                            </p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertyType' | translate}}</p>
                            <p>{{subcategoryLabel()}}</p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertyUse' | translate}}</p>
                            <p>{{getUsage()}}</p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertyYear' | translate}}</p>
                            <p>{{formValues.yearOfConstruction}}</p>
                        </div>
                        <div class="line">
                            <p>{{'dataSummary.propertySize' | translate}}</p>
                            <p>{{formValues.area}} m²</p>
                        </div>
                        <!-- <div class="line">
                            <p>Value of the content</p>
                            <p>{{formValues.movableinsuranceSum}}</p>
                        </div>
                        <div class="line">
                            <p>Claims in the last 5 years</p>
                            <p>{{!!formValues.claimsExist ? 'Да' : 'Не'}}</p>
                        </div> -->
                        <div class="line">
                            <p>&nbsp;</p>
                            <p class="edit">
                                <a routerLink="/object-details" (click)="this.trackService.pushEventTracking('navigationButton', 'Edit')">
                                    <nx-icon name="edit"
                                             size="s"></nx-icon>
                                    {{'dataSummary.edit' | translate}}
                                </a>
                            </p>
                        </div>
                    </qbe-bluebox>
                </div>
            </div>
        </qbe-panel-component>
    </div>
    <div class="panel">
        <qbe-panel-component>
            <div class="row mobifix-vd"
                 nxRow>
                <div nxCol="12, 12, 4">
                    <h2 class="panel-header">{{'dataSummary.ownerDetails' | translate}}</h2>
                    <div class="illustration illustration-laptop">
                        <img aemNormalizeUrl alt="Man with laptop" src="/assets/img/man_with_laptop.svg">
                    </div>
                </div>
                <div class="vehicle-data"
                     nxCol="12, 12, 5"
                     colOffset="0,0,2">
                    <div class="first-box">
                        <qbe-bluebox>
                            <div class="line">
                                <p>{{'dataSummary.ownerEgn' | translate}}</p>
                                <p class="capitalize">{{formValues.ownerData?.egn}}</p>
                            </div>
                            <!-- <div class="line">
                                <p>{{'dataSummary.ownerEgn' | translate}}</p>
                                <p class="capitalize">{{formValues.dateOfBirth}}</p>
                            </div> -->
                            <div class="line">
                                <p>{{'dataSummary.insuranceStartDate' | translate}}</p>
                                <p class="capitalize">{{formValues.insuranceStart | date: 'dd.MM.yyyy'}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.propertyLoan' | translate}}</p>
                                <!-- <p class="capitalize">{{formValues.isFinancedThroughLoan === 'Y' ? 'Да' : 'Не'}}</p> -->
                                <p *ngIf="formValues?.isFinancedThroughLoan === 'Y'">{{'dataSummary.answerYes' | translate}}</p>
                                <p *ngIf="formValues?.isFinancedThroughLoan !== 'Y'">{{'dataSummary.answerNo' | translate}}</p>
                            </div>
                            <div class="line">
                                <p>&nbsp;</p>
                                <p class="edit">
                                    <a routerLink="/object-additional-details" (click)="this.trackService.pushEventTracking('navigationButton', 'Edit')">
                                        <nx-icon name="edit"
                                                 size="s"></nx-icon>
                                        {{'dataSummary.edit' | translate}}
                                    </a>
                                </p>
                            </div>
                        </qbe-bluebox>
                    </div>
                    <div>
                        <qbe-bluebox>
                            <div *ngIf="!isOwnerCompany()" class="line">
                                <p>{{'dataSummary.ownerFirstName' | translate}}</p>
                                <p class="capitalize">{{formValues?.ownerData?.firstName}}</p>
                            </div>
                            <div *ngIf="!isOwnerCompany()" class="line">
                                <p>{{'dataSummary.ownerMiddleName' | translate}}</p>
                                <p>{{formValues?.ownerData?.middleName}}</p>
                            </div>
                            <div *ngIf="!isOwnerCompany()" class="line">
                                <p>{{'dataSummary.ownerLastName' | translate}}</p>
                                <p>{{formValues?.ownerData?.lastName}}</p>
                            </div>
                            <div *ngIf="isOwnerCompany()" class="line">
                                <p>{{'dataSummary.companyName' | translate}}</p>
                                <p>{{formValues?.ownerData?.companyName}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.ownerPhoneNumber' | translate}}</p>
                                <p>{{formValues?.ownerData?.countryCode + formValues?.ownerData?.phoneNumber}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.ownerEmail' | translate}}</p>
                                <p>{{formValues?.ownerData?.email}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.ownerPostalCode' | translate}}</p>
                                <p>{{formValues?.ownerData?.postCode}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.ownerCity' | translate}}</p>
                                <p>{{formValues?.ownerData?.cityName}}</p>
                            </div>
                            <div class="line">
                                <p>{{'dataSummary.ownerStreet' | translate}}</p>
                                <p>{{formValues?.ownerData?.address}}</p>
                            </div>
                            <div class="line">
                                <p>&nbsp;</p>
                                <p class="edit">
                                    <a routerLink="/contact-details" (click)="this.trackService.pushEventTracking('navigationButton', 'Edit')">
                                        <nx-icon name="edit"
                                                 size="s"></nx-icon>
                                        {{'dataSummary.edit' | translate}}
                                    </a>
                                </p>
                            </div>
                        </qbe-bluebox>
                    </div>
                </div>
            </div>
        </qbe-panel-component>
    </div>
    <div class="panel">
        <qbe-panel-component>
            <div class="row mobifix-vd"
                 nxRow>
                <div nxCol="12, 12, 4">
                    <h2 class="panel-header">{{'dataSummary.packageDetails' | translate}}</h2>
                    <div class="illustration illustration-certificates">
                        <img aemNormalizeUrl alt="Man pointing at certificates" src="/assets/img/man_pointing_at_certificates_1.svg">
                    </div>
                </div>
                <div class="vehicle-data"
                     nxCol="12, 12, 5"
                     colOffset="0,0,2">
                    <div class="first-box">
                        <qbe-bluebox>
                            <div class="line">
                                <p>{{'dataSummary.insuredSum' | translate}}</p>
                                <p>&nbsp;</p>
                            </div>
                            <ng-container
                                    *ngIf="{currency: sharedService.getCurrency() | async} as o">
                                <div *ngIf="formValues.immovableinsuranceSumRecommended" class="line">
                                    <p>{{'dataSummary.property' | translate}}</p>
                                    <p>{{formValues.immovableinsuranceSumRecommended | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}</p>
                                </div>
                                <div *ngIf="formValues.movableinsuranceSumRecommended" class="line">
                                    <p>{{'dataSummary.content' | translate}}</p>
                                    <p>{{formValues.movableinsuranceSumRecommended | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}</p>
                                </div>

                                <div class="line">
                                    <p>{{'dataSummary.selectedPackage' | translate}}</p>
                                    <p>{{chosenPackageLabel}}</p>
                                </div>
                                <div class="line">
                                    <p>{{'dataSummary.earthquake' | translate}}</p>
                                    <!-- <p>{{formValues?.isEarthQuakeIncluded === 'T' ? 'Да' : 'Не'}}</p> -->
                                    <p *ngIf="formValues?.isEarthQuakeIncluded === 'T'">{{'dataSummary.answerYes' | translate}}</p>
                                    <p *ngIf="formValues?.isEarthQuakeIncluded !== 'T'">{{'dataSummary.answerNo' | translate}}</p>
                                </div>
                                <div class="line">
                                    <p>{{'dataSummary.price' | translate}}</p>
                                    <p>{{getPremium(calculatedPremiums$ | async, formValues.selectedPayments, formValues.chosenPackageId) | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}</p>
                                </div>
                                <div class="line">
                                    <p>{{'dataSummary.paymentFrequency' | translate}}</p>
                                    <p>{{'dataSummary.pricePeriod' + formValues?.selectedPayments | translate}}</p>
                                </div>
                                <div class="line">
                                    <p>{{'dataSummary.deductible' | translate}}</p>
                                    <p *ngIf="formValues?.isDeductibleIncluded === 'T'">{{deductible | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}</p>
                                    <p *ngIf="formValues?.isDeductibleIncluded !== 'T'">{{'dataSummary.answerNo' | translate}}</p>
                                </div>
                                <div class="line">
                                    <p>&nbsp;</p>
                                    <p class="edit">
                                        <a routerLink="/package-selection" (click)="this.trackService.pushEventTracking('navigationButton', 'Edit')">
                                            <nx-icon name="edit"
                                                     size="s"></nx-icon>
                                            {{'dataSummary.edit' | translate}}
                                        </a>
                                    </p>
                                </div>
                            </ng-container>
                        </qbe-bluebox>
                    </div>
                </div>
            </div>
        </qbe-panel-component>
    </div>
</form>
</div>

<ng-template #loadingSpinner>
    <div class="wrapper loading" nxLayout="grid">
        <app-loading [title]="preloading"></app-loading>
    </div>
</ng-template>